import { render } from "./Currents.vue?vue&type=template&id=ee8c6e8a&ts=true"
import script from "./Currents.vue?vue&type=script&lang=ts"
export * from "./Currents.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__